import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _02_PLANT_FOOD:Partial<EcosystemServiceModel> ={
  id:'plant-food',
  pos:2,
  image: "/images/ecoservices/plant_food.jpg",
  code: ["1.1.5.1"],
  unit:'plant food',
  assetType:'other',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "kg",
      element: "plants food",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
